var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationEasyToImplement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 605,
    height: 444,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-24.2%",
    y: "-37.9%",
    width: "159.6%",
    height: "193.3%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.212302148 0 0 0 0 0.325209598 0 0 0 0 0.419299139 0 0 0 0.300726617 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    x: 0,
    y: 0,
    width: 445,
    height: 284,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 55)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1B262F",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63 55h429a8 8 0 018 8v32H55V63a8 8 0 018-8z",
    fill: "#2E3F4D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71 67)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#BA4270",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#527695",
    cx: 30.4,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#36536B",
    cx: 52.8,
    cy: 8,
    r: 8
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "RobotoMono-Regular, Roboto Mono",
    fontSize: 13,
    fill: "#FBFCFE",
    transform: "translate(55 55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 86
  }, "&lt;form id=&quot;form-id&quot; method=&quot;GET&quot;&gt; &lt;/form&gt;"), /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 106
  }, "&lt;script"), /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 126
  }, " src=&quot;https://loremipsum.com/api.js&quot;"), /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 146
  }, " data-client-name=&quot;Your Company&apos;s Name&quot;"), /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 166
  }, " data-form-id=&quot;form-id&quot;"), /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 186
  }, " data-key=&quot;test_key&quot;"), /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 206
  }, " data-product=&quot;transactions&quot;"), /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 226
  }, " data-env=&quot;sandbox&quot;&gt;"), /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 246
  }, "&lt;/script&gt;")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEasyToImplement);
export default __webpack_public_path__ + "static/media/illustration-easy-to-implement.c3a3171cd344b84c6d8f2f83f3d32caf.svg";
export { ForwardRef as ReactComponent };